import React from 'react';

/**
 * BrandName Component
 * Displays "CREATE 3D Works" with custom Uncage-style font
 * "CREATE 3D" is bold, "Works" is regular weight
 * Font sizes increased by 50% from default
 */
const BrandName = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    xs: 'text-lg',      // was text-sm
    sm: 'text-xl',      // was text-base
    md: 'text-3xl',     // was text-xl
    lg: 'text-4xl',     // was text-2xl
    xl: 'text-5xl',     // was text-3xl
    '2xl': 'text-6xl',  // was text-4xl
    '3xl': 'text-7xl',  // was text-5xl
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return (
    <span className={`brand-name ${sizeClass} ${className}`}>
      <span className="brand-name-bold">CREATE 3D</span> Works
    </span>
  );
};

export default BrandName;
